var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('timeline',{attrs:{"timeline-items":_vm.dataTimeline,"message-when-no-items":'no items',"uniqueTimeline":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }